import { computed } from "vue";
import { useRouter } from "vue-router";
import { useThemeContext } from "@/core/composables";
import { useKeycloakSignIn } from "./useKeycloakSignIn";

const PASSWORD_AUTHENTICATION_TYPE = "Password";

export function useSignIn() {
  const { themeContext } = useThemeContext();
  const { signIn: signInWithKeycloak } = useKeycloakSignIn();
  const router = useRouter();

  const hasPasswordAuthentication = computed(() => {
    const authenticationTypes: string[] = themeContext.value.storeSettings?.authenticationTypes?.length
      ? (themeContext.value.storeSettings.authenticationTypes as string[])
      : [PASSWORD_AUTHENTICATION_TYPE];

    return authenticationTypes.includes(PASSWORD_AUTHENTICATION_TYPE);
  });

  function goToSignIn(returnUrl: string) {
    const useKeycloak = !hasPasswordAuthentication.value;

    signInWithKeycloak(returnUrl, useKeycloak);

    if (!useKeycloak) {
      router.push({ name: "SignIn", query: { returnUrl } });
    }
  }

  return { hasPasswordAuthentication, goToSignIn };
}
